module.exports = __webpack_public_path__ + "static/media/piggy-bank.52be880d.svg";